import {
 get,
 post
} from "@/axios/http.js";
import qs from 'qs'

const EXAMPLE_APP_CONFIG = {
 "App-Key": "6805e765ec5e343d1c98c0a4",
 "Sign": "6uyil22UyckA0IH-dDvLEWs-ccR0s.zehPiq.MtTj786wquM7f23wH-gqz30V6xE.Idir6tpUq7lBracu.K0zugzOGwoA5E0PBc0QibuDC1A8ZmbaJnk8O485wYZ5233",
}
export const getFilterList = (data) => {
 let params = {
  "App-Key": EXAMPLE_APP_CONFIG['App-Key'],
  "Sign": EXAMPLE_APP_CONFIG['Sign'],
  "worksheetId": "64e4a01c6bd3e9ac8e08ba94",
  "pageSize": 100000,
  "pageNo": 1,
  "sortField": "",
  "isAsc": false,
  "keywords": "",
  "filters": []
 }
 Object.assign(params, data)
 return post('/api/v2/worksheet/getFilterRows', params, { cookie: null }, false)
}
export const getRowById = (data) => {
 let params = {
  "App-Key": EXAMPLE_APP_CONFIG['App-Key'],
  "Sign": EXAMPLE_APP_CONFIG['Sign'],
  "worksheetId": "",
  "rowId": ""
 }
 Object.assign(params, data)
 return post('/api/v2/worksheet/getRowById', params, { cookie: null }, false)
}


export const getWXAccessToken = (url) => get(`/api/wechat/jsSignatureV2?url=${url}`)